import React, { useState, useEffect } from "react";
import { Form, Button, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";

const DEFAULT_HEADER = `<table width="100%" style="border-bottom:1px solid #eee;"><tr>
<td align="left" style="padding:10px">
  <img src="https://dzemat.de/wp-content/uploads/2022/12/logo.png" alt="Logo" height="50" style="filter: brightness(0) saturate(100%) invert(17%) sepia(97%) saturate(1012%) hue-rotate(97deg) brightness(95%) contrast(98%);" />
</td>
<td align="right" style="padding:10px;font-size:14px;color:#555;">
    IGBD – Gemeinde Köln Gazi Husrevbeg e.V.<br/>
    Vogelsanger Str. 210, 50825 Köln<br/>
    info@dzemat.de<br/>
    +49 0221 5461807
</td>
</tr></table>`;

const DEFAULT_FOOTER = `<div style="border-top:1px solid #eee;padding:10px 0 0 0;font-size:12px;color:#888;text-align:center;">
    IGBD – Gemeinde Köln Gazi Husrevbeg e.V. | Vogelsanger Str. 210, 50825 Köln | info@dzemat.de | +49 0221 5461807<br/>
    Vereinsregister: Amtsgericht Köln, VR 10678<br/>
    Impressum | Datenschutz<br/>
    ©2025 IGBD - Gemeinde Köln Gazi Husrevbeg e. V.
</div>`;

export default observer(function EmailLayoutSettingsPage() {
    const { emailTemplateStore } = useStore();
    const { t } = useTranslation();
    const [header, setHeader] = useState<string>(DEFAULT_HEADER);
    const [footer, setFooter] = useState<string>(DEFAULT_FOOTER);

    useEffect(() => {
        (async () => {
            const settings = await emailTemplateStore.fetchLayoutSettings();
            if (settings && (settings.header || settings.footer)) {
                setHeader(settings.header || DEFAULT_HEADER);
                setFooter(settings.footer || DEFAULT_FOOTER);
            }
        })();
    }, [emailTemplateStore]);

    const handleSave = async () => {
        await emailTemplateStore.saveLayoutSettings({ header, footer });
        alert(t("emails.layout.saved"));
    };

    return (
        <Segment>
            <h2>{t("emails.layout.title")}</h2>
            <Form>
                <Form.TextArea
                    label={t("emails.layout.header")}
                    value={header}
                    onChange={e => setHeader(e.target.value)}
                    rows={6}
                />
                <Form.TextArea
                    label={t("emails.layout.footer")}
                    value={footer}
                    onChange={e => setFooter(e.target.value)}
                    rows={6}
                />
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                    <Button onClick={handleSave} positive>
                        {t("emails.layout.save")}
                    </Button>
                </div>
            </Form>
            <h4>{t("emails.layout.preview")}</h4>
            <Segment>
                <div dangerouslySetInnerHTML={{ __html: header }} />
                <div style={{ minHeight: 100, padding: 20, background: "#fafafa" }}>
                    <em>{t("emails.layout.bodyPlaceholder")}</em>
                </div>
                <div dangerouslySetInnerHTML={{ __html: footer }} />
            </Segment>
        </Segment>
    );
});
